// src/components/container/WhyChooseUs.jsx
import { FaCut, FaHandsHelping, FaHome, FaMapMarkedAlt, FaStar, FaUserFriends } from "react-icons/fa";
import '../../../assets/css/container/whychooseus.css';

const WhyChooseUs = () => {
  const reasons = [
    {
      title: 'Expert Stylists',
      description: 'Skilled stylists offer personalized and high-quality services.',
      icon: <FaCut />,
    },
    {
      title: 'Welcoming Atmosphere',
      description: 'Enjoy a warm, family-oriented salon environment.',
      icon: <FaHome />,
    },
    {
      title: 'Comprehensive Services',
      description: 'A diverse array of services for all your hair needs.',
      icon: <FaUserFriends />,
    },
    {
      title: 'Community Involvement',
      description: 'Supporting and empowering the local community.',
      icon: <FaHandsHelping />,
    },
    {
      title: 'Positive Reputation',
      description: 'Strong reputation for excellent service and results.',
      icon: <FaStar />,
    },
    {
      title: 'Convenient Locations',
      description: 'Easily accessible locations in Woodbridge, Virginia.',
      icon: <FaMapMarkedAlt />,
    },
  ];

  return (
    <section className="why-choose-us fade-in">
      <div className="intro">
        <h2>Why People Choose Us</h2>
        <p>
          Discover what makes our salons the preferred choice for so many clients. 
          We combine expertise, atmosphere, and community values to offer you an unparalleled experience.
        </p>
      </div>

      <div className="reasons">
        {reasons.map((reason, index) => (
          <div key={index} className="reason-card">
            <div className="icon">{reason.icon}</div>
            <h3>{reason.title}</h3>
            <p>{reason.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
